import { LabelItem, LabelItemType, PrintLabelInfos, labelEditorSlice, printZoneToCSS } from 'cdx-common';
import React, { CSSProperties, useState } from 'react';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { RootState, appStore } from 'store';

const content = (item: LabelItem): React.ReactNode => {
    switch (item.type) {
        case LabelItemType.QRCODE:
            return <div style={{ position: 'relative', width: '100%', height: '100%', pointerEvents: 'none' }}>
                <div style={{ height: "auto", margin: "0 auto", width: "100%", opacity: 0.1, pointerEvents: 'none' }}>
                    <QRCode
                        style={{ height: "auto", maxWidth: "100%", width: "100%", pointerEvents: 'none' }}
                        value={'1234567890'}
                    />
                </div>
                <div style={{ textShadow: '0px 0px 4px rgba(255, 255, 255, 1)', position: 'absolute', top: 0, left: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', }}>{item.mapping}</div>
            </div>;
        case LabelItemType.BARCODE:
            return <div style={{ position: 'relative', pointerEvents: 'none' }}>
                <span style={{ textShadow: '0px 0px 4px rgba(255, 255, 255, 1)' }}>{item.mapping}</span>
                <span style={{ opacity: 0.25, position: 'absolute', top: 0, left: 0 }}><Barcode width={200} height={40} value={'1234567890'} /></span>
            </div>;
        case LabelItemType.STATIC_TEXT:
            return item.value;
        default:
            return item.mapping;
    }
};

export const PrintLabelItemRenderer = (props: { infos: PrintLabelInfos, index: number; }) => {
    return <div className={'labelElement ' + elementClass(props.infos.items[props.index])}
        draggable
        style={normalizedProps(props.infos.items[props.index])}>{
            content(props.infos.items[props.index])
            /*props.infos.items[props.index].type === LabelItemType.STATIC_TEXT ? props.infos.items[props.index].value : props.infos.items[props.index].mapping*/
        }</div>;
};

export const CurrentLabelItemRenderer = (props: { index: number, offset: number; }) => {

    const item = useSelector((state: RootState) => state.labelEditor.currentLabel?.items[props.index]);
    if (!item) return <></>;
    const css = normalizedProps(item);
    return <div className={'labelElement' + (item.type === LabelItemType.BARCODE ? ' barcode' : '')}
        style={css}>{
            item.type === LabelItemType.STATIC_TEXT ? item.value : <DynamicContent css={css} offset={props.offset} index={props.index} />
        }</div>;

};



export const EditableLabelItem = (props: { index: number; }) => {


    const selectedLabelItem = useSelector((state: RootState) => state.labelEditor.selectedLabelItem);
    const item = useSelector((state: RootState) => state.labelEditor?.currentLabel?.items[props.index]);
    if (!item) return <></>;

    const [editing, setEditing] = useState(false);



    const renderDiv = () => {
        return <div data-label-index={props.index} className={'labelElement ' + elementClass(item) + (selectedLabelItem == props.index ? ' active' : '') + (' editable')}
            onDoubleClick={() => {
                if (item.type === LabelItemType.STATIC_TEXT) {
                    setEditing(true);
                }
            }}
            style={normalizedProps(item)}>{content(item)}</div>;
    };
    const renderInput = () => {
        return <input
            data-label-index={props.index}
            type='text'
            className={'labelElement editable active ' + elementClass(item)}
            style={normalizedProps(item)}
            onBlur={() => {
                setEditing(false);
            }}
            onChange={(event) => {
                appStore.dispatch(labelEditorSlice.actions.updatePrintLabelItemAttrs({
                    index: props.index,
                    attrs: {
                        value: event.target.value
                    }
                }));
            }}
            value={item.value} />;
    };

    return <>{editing && item.type === LabelItemType.STATIC_TEXT ? renderInput() : renderDiv()}</>;
};

const DynamicContent = (props: { index: number, offset: number, css: CSSProperties; }) => {

    const item = useSelector((state: RootState) => state.labelEditor.currentLabel?.items[props.index]);
    const column = useSelector((state: RootState) => item ? state.labelEditor.currentLabel?.configuration.columnMapping[item.mapping ?? ''] : undefined);
    const value = useSelector((state: RootState) => state.labelEditor.currentSheet?.values[props.offset]?.[column ?? -1]);

    if (!item) return <></>;
    const wrapLink = (content: React.ReactNode): React.ReactNode => {

        if ((value + '').startsWith('http://') || (value + '').startsWith('https://')) {
            return <a href={value + ''}>{content}</a>;
        }
        return content;
    };

    switch (item.type) {
        case LabelItemType.QRCODE:
            let val: string | undefined = undefined;
            if (item.value && value) {
                val = item.value.replace('[value]', value + '');
            } else {
                val = (value ?? item.value ?? '1234567890') + '';
            }
            return wrapLink(<div style={{ height: "auto", margin: "0 auto", width: "100%" }}>
                <QRCode
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={val ?? '1234567890'}
                />
            </div>);
        case LabelItemType.BARCODE:
            console.log('props.css', props.css, parseInt(props.css.fontSize + ''), parseInt(props.css.width + ''), parseInt(props.css.height + ''), ((value ?? item.value ?? '') + ''));
            return <Barcode lineColor='black' margin={0} height={parseInt(props.css.height + '')} fontSize={parseInt(props.css.fontSize + '')} value={(value ?? item.value ?? '') + ''} />;
        default:
            return wrapLink(value ?? item.value ?? '');

    }

};

const normalizedProps = (item: LabelItem): CSSProperties => {
    let resultProps: CSSProperties = {
        ...item.props,
        fontSize: item.props?.fontSize + 'px',
        lineHeight: item.props?.fontSize + 'px'
    };
    return printZoneToCSS(item.props, resultProps);
};

const elementClass = (item: LabelItem): string => {
    let className: string = '';
    switch (item.type) {
        case LabelItemType.DYNAMIC_TEXT:
            className += ' labelDynamicText';
            break;
        case LabelItemType.STATIC_TEXT:
            className += ' labelStaticText';
            break;
        case LabelItemType.IMAGE:
            className += ' image';
            break;
        case LabelItemType.BARCODE:
            className += ' barcodeitem';
            break;
        case LabelItemType.QRCODE:
            className += ' qrcode';
            break;
        default:
            return '';
    }
    if (item.groupable === true) {
        className += ' groupable';
    }
    return className;
};
